/**
 * Base URL of the marketing site that serves the presentation. Overridable for
 * local/preview environments, same convention as `VITE_HUNTS_APP_URL` in
 * `RequireToursAccess`. The API knows this URL too (as `MARKETING_SITE_URL`) and
 * stamps `shareUrl` onto create responses; this constant covers the reads, where
 * only the token comes back.
 */
// The `www` host, not the apex: the apex only 301s to www, and a link that is
// about to be pasted into an email should not spend a redirect hop — nor differ
// from the `shareUrl` the API returns on create (its MARKETING_SITE_URL is www).
const MARKETING_SITE_URL =
  import.meta.env.VITE_MARKETING_SITE_URL ?? 'https://www.destinationtours.com';

/** The presentation route, and the query param carrying a share token. */
const DECK_PATH = '/deck';
const SHARE_TOKEN_PARAM = 's';

/**
 * Builds the link a prospect receives for a share.
 *
 * @param token - The share's token, as returned by the API.
 * @returns The absolute `/deck?s=…` URL to send, or null without a token.
 */
export function buildDeckShareUrl(token: string | undefined | null): string | null {
  if (!token) return null;
  return `${MARKETING_SITE_URL}${DECK_PATH}?${SHARE_TOKEN_PARAM}=${encodeURIComponent(token)}`;
}
